<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { RouterLink } from 'vue-router'
import ArrowIcon from '@/components/shared/ArrowIcon.vue'

const { t } = useI18n()
</script>

<template>
  <section class="relative bg-slate-900 py-24 overflow-hidden">
    <div
      class="absolute inset-0 pointer-events-none"
      style="background: radial-gradient(ellipse 70% 50% at 50% 50%, rgba(2,132,199,0.16) 0%, transparent 70%);"
    ></div>

    <div class="relative z-10 max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
      <h2 class="text-3xl md:text-5xl font-black text-white leading-tight">
        {{ t('participants_lp.cta_banner.heading') }}
      </h2>
      <RouterLink
        to="/my/login"
        class="inline-flex items-center gap-2 mt-8 bg-sky-600 hover:bg-sky-500 text-white font-semibold rounded-lg px-10 py-4 text-lg transition-colors"
      >
        {{ t('participants_lp.cta_banner.cta') }}
        <ArrowIcon direction="right" class="w-4 h-4" />
      </RouterLink>
      <p class="mt-4 text-sm text-slate-500">
        {{ t('participants_lp.cta_banner.subtext') }}
      </p>
    </div>
  </section>
</template>
